import { service_handler } from '@services'

const service_name = 'reviews'

const MONTHS_VERBOSE = {
  '01': 'gennaio',
  '02': 'febbraio',
  '03': 'marzo',
  '04': 'aprile',
  '05': 'maggio',
  '06': 'giugno',
  '07': 'luglio',
  '08': 'agosto',
  '09': 'settembre',
  '10': 'ottobre',
  '11': 'novembre',
  '12': 'dicembre',
}

const EMPTY_REVIEWS_RESPONSE = new Promise((resolve) => {
  resolve({ data: { data: [] } })
}) 

export const get_reviews = (property_id) => property_id 
  ? service_handler(service_name, { property_id }, { modal: false }) 
  : EMPTY_REVIEWS_RESPONSE

export const MAX_REVIEWS = 6; 

export const format_review_date = (review) => {
  const raw_date = (review || {}).stayed_at
  if (!raw_date) {
    return ''
  }
  if (!raw_date.includes('-')) {
    return raw_date
  }
  const [year, month] = raw_date.split('-');
  return MONTHS_VERBOSE[month] + ' ' + year
}

const reviews_utilities = {
  get_reviews, 
  format_review_date
}
export default reviews_utilities